import axios, { type AxiosInstance, type AxiosRequestConfig, type AxiosResponse } from 'axios';

export interface ApiClientOptions {
  baseURL?: string;
  getToken?: () => string | null;
}

export class ApiClient {
  public readonly instance: AxiosInstance;

  constructor(options: ApiClientOptions) {
    this.instance = axios.create({
      baseURL: options.baseURL,
      headers: {
        'Content-Type': 'application/json'
      }
    });

    this.instance.interceptors.request.use((config) => {
      const token = options.getToken?.();
      if (token) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (config.headers as any)['authorization'] = `Bearer ${token}`;
      }
      return config;
    });

    this.instance.interceptors.response.use(
      (response: AxiosResponse) => response.data,
      (error) => Promise.reject(error)
    );
  }

  public get<T>(url: string, config?: AxiosRequestConfig) {
    return this.instance.get<T>(url, config);
  }

  public post<T>(url: string, data?: unknown, config?: AxiosRequestConfig) {
    return this.instance.post<T>(url, data, config);
  }

  public put<T>(url: string, data?: unknown, config?: AxiosRequestConfig) {
    return this.instance.put<T>(url, data, config);
  }

  public delete<T>(url: string, config?: AxiosRequestConfig) {
    return this.instance.delete<T>(url, config);
  }
}

export const API_BASE_URL =
  import.meta.env.VITE_API_HOST ?? 'http://localhost:4999';

export const apiClient = new ApiClient({
  baseURL: API_BASE_URL,
  getToken: () => localStorage.getItem('token')
});
